module.exports = __webpack_public_path__ + "img/icon-thumbs-up-full.8a64b372.svg";